export const SPINNER_MESSAGES_IDS = {
    CHECKING_DATA: 'spinner.checking_data',
    LOADING_DATA: 'spinner.loading_data',
    SAVING_DATA: 'spinner.saving_data',
    SEARCHING_DATA: 'spinner.searching',
    DOWNLOADING_FILE: 'spinner.downloading_file',
};

export const STATUS_COLOR_CODES = {
    ACTIVE: 'green',
    INACTIVE: 'red',
    INCOMPLETE: 'yellow',
};

export const UPLOADED_DOCUMENT_STATUSES = {
    INITIAL: 'INITIAL',
    REJECTED: 'REJECTED',
    SUBMITTED: 'SUBMITTED',
    VERIFIED: 'VERIFIED',
};

export const UPLOAD_MODAL_VIEWS = {
    HANDLE_DOCUMENT: 'HANDLE_DOCUMENT',
    REMOVE_DOCUMENT: 'REMOVE_DOCUMENT',
    UPLOAD_DOCUMENT: 'UPLOAD_DOCUMENT',
};

export const TAGS_PAGINATION_THRESHOLD = 10;

export const CHAT_LINKS = {
    CHAT_LOGIN_EN: 'CHAT_LOGIN_EN',
    CHAT_NOT_LOGIN_EN: 'CHAT_NOT_LOGIN_EN',
    CHAT_LOGIN_ES: 'CHAT_LOGIN_ES',
    CHAT_NOT_LOGIN_ES: 'CHAT_NOT_LOGIN_ES',
};

export const CALLER_INFORMATION_MAX_LENGTH = 10;
export const CALLER_INFORMATION_MID_LENGTH = 5;
export const POSITIVE = 'positive';
export const NEGATIVE = 'negative';
export const ALL = 'ALL';

export const SEP_END_DATE_SESSION_STORAGE_KEY = 'sepEndDate';
